import React, { useState } from 'react';
import Button, { ButtonType } from '../general-components/Button';
import SelectItem from '../general-components/SelectItem';
import FormInput from '../general-components/FormInput';
import ResultsComponent from '../search/ResultsComponent';
import { formatTimestamp } from '../../utils/utils';
import styles from './ScrapingOverview.module.css';

interface SearchResultRowProps {
    search: {
        _id: string;
        searchTerm: string;
        user: Array<{ email: string }>;
        createdAt: string;
        resultAmount: number;
        expectedHits?: number;
    };
    toResolve: string[];
    onCreateIssue?: (searchLogId: string) => void;
    onMarkForResolve?: (issueId: string) => void;
    onExpectedHitsChange: (searchId: string, value: number) => Promise<void>;
}

const SearchResultRow: React.FC<SearchResultRowProps> = ({
    search,
    toResolve,
    onCreateIssue,
    onMarkForResolve,
    onExpectedHitsChange,
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleResults = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div key={search._id} className={styles.searchRowContainer}>
            <div className={styles.searchRow}>
                <div className={styles.searchTerm}>{search.searchTerm}</div>
                <div className={styles.userEmail}>
                    <a
                        style={{
                            color: '#49d3fc',
                            textDecoration: 'underline',
                        }}
                        href={`mailto:${search.user[0]?.email}`}
                    >
                        {search.user[0]?.email}
                    </a>
                </div>
                <div className={styles.timestamp}>
                    {formatTimestamp(search.createdAt)}
                </div>
                <div className={styles.resultAmount}>{search.resultAmount}</div>
                <div className={styles.actionButton}>
                    <Button
                        small={true}
                        onClick={() => {
                            window.open(
                                'https://google.com/search?q=' +
                                    search.searchTerm +
                                    ' MRI safety',
                                '_blank'
                            );
                        }}
                        type={ButtonType.submit}
                    >
                        Open
                    </Button>
                </div>
                <div className={styles.actionButton}>
                    <Button
                        small={true}
                        onClick={toggleResults}
                        type={ButtonType.primary}
                    >
                        See Results
                    </Button>
                </div>

                {onCreateIssue && (
                    <div className={styles.actionButton}>
                        <Button
                            small={true}
                            onClick={() => onCreateIssue(search._id)}
                            type={ButtonType.primary}
                        >
                            Create Issue
                        </Button>
                    </div>
                )}
                {!onCreateIssue && <div className={styles.actionButton}></div>}

                {onMarkForResolve && (
                    <div className={styles.checkboxContainer}>
                        <SelectItem
                            defaultChecked={false}
                            type="checkbox"
                            value="Mark for resolving"
                            checked={toResolve.includes(search._id)}
                            onChange={() => onMarkForResolve(search._id)}
                        />
                    </div>
                )}
                {!onMarkForResolve && (
                    <div className={styles.checkboxContainer}></div>
                )}

                <div className={styles.inputContainer}>
                    <div style={{ width: '100px' }}>
                        <FormInput
                            defaultValue={search.expectedHits}
                            type="number"
                            onChange={async (e) => {
                                await onExpectedHitsChange(
                                    search._id,
                                    parseInt(e.target.value)
                                );
                            }}
                        />
                    </div>
                </div>
            </div>
            <div
                className={`${styles.resultsRow} ${isOpen ? styles.open : ''}`}
            >
                {isOpen && (
                    <ResultsComponent
                        term={search.searchTerm}
                        defaultSemantic={false}
                        isFullview={false}
                    />
                )}
            </div>
        </div>
    );
};

export default SearchResultRow;
